import {FC} from 'react';
import {LeftSecondMenu} from "../../barsEnvironment/leftMenu/components/leftSecondMenu";
import {Routes} from "./routes";
import {useSettingMain} from "./hooks/main/useSettingMain";


export const Settings:FC = () => {
    useSettingMain();
    return(
        <LeftSecondMenu>
            <Routes/>  
        </LeftSecondMenu>
    )
}
